export default function ProsConsSection() {
  return (
    <section id="prosncons" className="py-8 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-0">
        
        {/* Pros Section */}
        <div className="mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-6">
            ✅ Pros of Playing at AUS Casinos
          </h2>

          <div className="space-y-4">
            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Online casinos offer unparalleled convenience, allowing players to access thousands of games from anywhere at any time. Whether you're at home, commuting, or traveling, you can enjoy your favorite slots, table games, and live dealer experiences directly from your smartphone, tablet, or computer without visiting a physical casino.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              The variety of games available at online casinos far exceeds traditional casinos. Players can choose from thousands of slot titles, multiple blackjack variations, roulette, baccarat, poker, and specialty games. Platforms frequently update their games libraries, ensuring fresh entertainment options year-round.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Generous bonuses and promotions are a major advantage. New players get welcome bonuses, deposit matches, and free spins, while existing players receive reload bonuses, cashback, loyalty perks, and VIP rewards that extend gameplay and increase value.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Online casinos typically offer higher payout percentages due to lower operational costs. Many publish their RTP (Return to Player) rates, often above 96% for slots and 99% for table games, providing better odds and transparency with independently verified fairness certifications.
            </p>
          </div>
        </div>

        {/* Cons Section */}
        <div className="mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-6">
            ⚠️ Cons of Playing at AUS Casinos
          </h2>

          <div className="space-y-4">
            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Accessibility can be a double-edged sword. The 24/7 access makes it easier to lose track of time and money, potentially leading to problematic gambling behaviors if self-control measures aren’t in place.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Withdrawals may take 24 hours to several business days depending on payment method and verification. Identity checks and document reviews can delay access to winnings, which frustrates many players.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              A lack of social interaction is a drawback for players who enjoy the atmosphere of traditional casinos. While live dealer games help, online gambling still lacks the excitement, energy, and human interaction of a physical casino floor.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Technical issues such as disconnections, slow loading, and software bugs can affect gameplay. Additionally, players must carefully choose licensed and reputable casinos to avoid security risks or unreliable operators.
            </p>
          </div>
        </div>

        {/* Pro Tip Box */}
        <div className="mb-12">
          <div className="border-2 border-red-500 rounded-lg p-6 md:p-8 bg-white relative">
            
            {/* Icon Badge */}
            <div className="absolute -top-5 left-8">
              <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
                <i className="ri-lightbulb-line text-xl text-white"></i>
              </div>
            </div>
            
            <div className="pt-2">
              <p className="text-sm md:text-md text-gray-800 leading-relaxed mb-3">
                We encourage you to learn more about each payment method offered by online casinos before registering an account.
              </p>

              <p className="text-sm text-gray-600">
                <strong className="text-gray-900 italic font-semibold">Pro tip</strong> by William Southam
              </p>
            </div>

          </div>
        </div>

        {/* Conclusion */}
        <div>
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-6">
            Conclusion
          </h2>

          <div className="space-y-4">
            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              Navigating Australian online ewallet casinos requires evaluating licensing, game variety, payment options, security, and customer support. This review provides insights into bonuses, gaming libraries, payout speeds, and player experiences to help you make an informed choice.
            </p>

            <p className="text-base md:text-md text-gray-700 leading-relaxed">
              After thorough evaluation, iPay9 stands out as the #1 recommended casino for Australian players in the year. With a generous 3,888 A$ bonus + 133 free spins, extensive game library, fast withdrawals, and strong security, it delivers a superior playing experience. Always gamble responsibly and choose licensed platforms.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}
